module.exports = __webpack_public_path__ + "img/profile-bg.7d30d22c.svg";